module.exports = __webpack_public_path__ + "static/img/traning1.ba5053c3.png";